module.exports = __webpack_public_path__ + "static/media/icon_adding.abd91320.png";